import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {TargetType} from "../../utils/types/article_target";
import {articleContentTypeSession_template} from "./articleContentTypeSession_template";
import {ArticleSessionInterface} from "./articleSessionInterface";

declare var ko: any;
declare var page: any;

export class articleSessionTab_template extends vnTemplate {
    protected yearSelector: filterDropdown_template;
    public contentTypeExceptionsTargets: articleContentTypeSession_template;
    public parent: ArticleSessionInterface;

    protected getTemplateName(): string {
        return "articleSessionTab_template";
    }

    protected getTemplateHtml(): string {
        return `
            <div id="session-brand-target" class="form-body full-width" >
                <div class="form-group row" data-bind="visible: saveFallback()" style="width: 50%;justify-content: flex-start;">
                    <label class="form-label" for="fallback">Network Fallback</label>
                    <input type="text" name="fallback" id="fallback" class="input-text" data-bind="value: fallback, enable: !readOnly()" style="width: 9rem">
                </div>
                ${this.contentTypeExceptionsTargets.getHtmlBuild()}
                <strong class="form-sub-title ">Company Level</strong>
                <div class="form-group">
                    
                    <table class="list-action">
                        <thead class="sticky">
                            <th style="position: sticky;top: 0;">
                               ${this.yearSelector.getHtmlBuild()}
                            </th>
                            <!-- ko foreach: defaultMonths -->
                            <th><span data-bind="text: $data"></span></th>
                            <!-- /ko -->
                        </thead>
                         <tbody data-bind="foreach: sessionTargets">
                            <tr class="brand-row">
                               <td>
                                  <div class="flex">
                                     <span data-bind="text: brandName, css: iconImage" class="dark"></span>
                                     <!-- ko ifnot: $parent.readOnly() -->
                                        <button title="set exception" class="btn icon border only-icon i-t-option" type="button" data-bind="event: { click: $parent.onClickBrandContentType }, class: exceptionDisableClass"></button>
                                     <!-- /ko -->
                                     <button title="see exception" class="btn icon border only-icon" type="button" data-bind="css: { 'i-simplify' : collapseExpand(), 'i-expand' : !collapseExpand() }, event: { click: onClickCollapseEvent}, class: collapseDisableClass"></button>
                                  </div>
                               </td>
                               
                               <!-- ko ifnot: $parent.readOnly -->
                                   <!-- ko foreach: months -->
                                   <td>
                                      <input type="number" class="input-text" data-bind="value: $data.sessionTarget, event: {blur: $parent.onBlurInputSessionTarget }, attr: {'id' :  $parent.idBrand + '-' + $data.month, 'data-previous-value': $data.sessionTarget}, enable: $data.enabled" min="0" max="99999">
                                   </td>
                                   <!-- /ko -->
                               <!-- /ko -->
                               <!-- ko if: $parent.readOnly -->
                                   <!-- ko foreach: months -->
                                   <td class="align-right" style="padding: 0 .5rem 0 3.5rem">
                                      <span class="" style="font-size: 1.1rem;font-weight:400;" data-bind="text: $data.sessionTarget"></span>
                                   </td>   
                                   <!-- /ko -->
                               <!-- /ko -->
                            </tr>
                            <!-- ko if: (collapseExpand()) -->
                            <!-- ko foreach: contentTypeList -->
                            <tr style="background-color: #f8f8f8">
                               <td class="align-left" >
                                  <span style="font-weight:700;" data-bind="text: $data.contentTypeName"></span>
                               </td>
                               <!-- ko foreach: exceptionMonths -->
                               <td class="align-right" >
                                  <span style="font-size: 1.1rem;font-weight:400;" data-bind="text: $data.sessionTarget"></span>
                               </td>
                               <!-- /ko -->
                            </tr>
                            <!-- /ko -->
                            <!-- /ko -->
                         </tbody>
                  </table>
               </div>
               
               <!-- ko ifnot: readOnly() -->
               <div class="form-footer">
                  <button class="btn" data-bind="event: { click: onClickCancel }" >Cancel</button>
                  <button class="btn highlight" data-bind="event: { click: onClickSave }" >Save</button>
               </div>
               <!-- /ko -->
               
            </div>
        `;
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-form-body"];
    }

    protected buildViewModel(): any {
        let self = this;

        return {
            readOnly: ko.observable(true),
            type: ko.observable(TargetType.SUCCESS),
            fallback: ko.observable(500),
            saveFallback: ko.observable(false),
            defaultMonths: ko.observableArray([]),
            sessionTargets: ko.observableArray([]),
            selectedYear: ko.observable(''),
            unsavedBrandTargets: ko.observable(false),
            unsavedContentTypes: ko.observableArray([]),
            isRefreshContentType: ko.observable(false),
            onClickSave: function(data, event) {
                self.onClickSave();
            },
            onClickCancel: function(data, event) {
                self.onClickCancel();
            },
            onClickBrandContentType: function (data, event) {
                self.onClickBrandContentType(data);
            },
            onClickBrandSaveHide: function () {
                self.onClickBrandSaveHide();
            },
            onClickBrandContentTypeSaveHide: function() {
                self.onClickBrandContentTypeSaveHide();
            }
        };
    }

    protected initPartial() {

        this.yearSelector = new filterDropdown_template('yearSelector', this.getTemplateViewModel(), this.caller);
        this.yearSelector.setLabel('Year');

        this.contentTypeExceptionsTargets = new articleContentTypeSession_template('contentTypeTargets', this.getTemplateViewModel(), this.caller);
        this.contentTypeExceptionsTargets.setParent(this);
        this.contentTypeExceptionsTargets.setType(this.getType())
        this.contentTypeExceptionsTargets.hide();

        this.initializeDefaultMonths();
    }

    public setParent(parent: ArticleSessionInterface): void {
        this.parent = parent;
    }

    public isReadOnly(readOnly: boolean) {
        this.getTemplateViewModel().readOnly(readOnly);
    }

    private initializeDefaultMonths() {
        this.getTemplateViewModel().defaultMonths(['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']);
    }

    public setType(type: string): void {
        this.getTemplateViewModel().type(type);
    }

    public getType(): string {
        return this.getTemplateViewModel().type();
    }


    public setListingSessionTargets(successTargets): void {

        this.getTemplateViewModel().sessionTargets([]);
        let self =  this;

        let builtTargets = [];
        for (let key in successTargets) {
            let contentTypeList = [];
            let contentTypes = successTargets[key].contentTypes;

            // Content Types
            for (let contentTypeKey in contentTypes) {
                contentTypeList.push({
                    idContentType: contentTypes[contentTypeKey].idContentType,
                    contentTypeName: contentTypes[contentTypeKey].contentTypeName,
                    exceptionMonths: contentTypes[contentTypeKey].exceptionMonths,
                });
            }

            let sessionTarget = ko.observable({
                idBrand: successTargets[key].idBrand,
                brandName: successTargets[key].brandName,
                iconImage: successTargets[key].iconImage,
                months: successTargets[key].targetMonths,
                contentTypeList: contentTypeList,
                exceptionDisableClass: (successTargets[key].hasTargetMonths ? '' : 'is-disable'),
                collapseDisableClass: ((contentTypeList.length <= 0) ? 'is-disable' : ''),
                collapseExpand: ko.observable(false),
                enabledMonths: successTargets[key].enabledMonths,
                onClickCollapseEvent: function (data) {
                    self.onClickCollapseEvent(data);
                },
                onBlurInputSessionTarget: function(data, event) {
                    self.onBlurInputSessionTarget(data, event);
                }
            });
            builtTargets.push(sessionTarget);
        }

        this.getTemplateViewModel().sessionTargets(builtTargets);
    }

    public onClickSave(): void {
        this.caller.save();
    }

    public onClickCancel(): void {

        let hasChange = this.hasUnsavedBrandSessionTarget();
        if (hasChange) {
            if (confirm('Are you sure you want to cancel? any unsaved change will be lost.')) {
                this.parent.redirectToView();
            }
        } else {
            this.parent.redirectToView();
        }
    }


    public onClickBrandContentType(data): void {

        this.contentTypeExceptionsTargets.setType(this.getType());
        this.contentTypeExceptionsTargets.setSelectedBrandSessionTarget(data);
    }

    public onClickCollapseEvent(data) {
        data.collapseExpand(!data.collapseExpand());
    }

    public getSelectedYear() {
        return this.yearSelector.getTemplateViewModel().selectedOption();
    }

    public getSessionTargets() {
        return this.getTemplateViewModel().sessionTargets();
    }

    public setSessionTargets(sessionTargets): void {
        this.getTemplateViewModel().sessionTargets(sessionTargets);
    }

    public onClickBrandSaveHide() {
        this.toggleBrandSaveDialogVisibility();
        this.caller.updateSessionBrandDisplay();
        this.resetUnsavedBrandSessionTarget();
    }


    public onClickBrandContentTypeSaveHide() {
        // Select back the previous year
        this.toggleBrandContentTypeSaveDialogVisibility();
    }

    /** Session target brand year dropdown **/
    public setYearSelector(years, currentYear):void {

        this.yearSelector.setOptions(years);
        this.setYearSelectorSelectedOption(currentYear);
    }

    public setYearSelectorSelectedOption(year) {
        this.yearSelector.setSelectedOption(year);
    }

    public getYearSelector(): string {
        return this.yearSelector.getTemplateViewModel().selectedOption();
    }

    /**
     * Returns a list of session brands to be saved in the system
     */
    public getViewModelForRequest() {
        let selectedYear = this.getSelectedYear();
        let sessionTargetValues = [];


        this.getTemplateViewModel().sessionTargets().forEach((item) => {
            let sessionTargetMonths = [];

            for (let key in item().months) {
                if (item().months[key].sessionTarget > 0) {
                    sessionTargetMonths.push(item().months[key]);
                }
            }

            sessionTargetValues.push({
                brand: item().brandName,
                idBrand: item().idBrand,
                year: selectedYear,
                months: sessionTargetMonths,
                contentTypes: []
            });
        });

        return {
            type: this.getType(),
            fallback: this.getFallback(),
            saveFallback: this.getSaveFallback(),
            list: sessionTargetValues
        };
    }


    /**
     * Set the selected year of the session target brands
     * @param selectedYear
     */
    public setSelectedYear(selectedYear): void {
        this.getTemplateViewModel().selectedYear(selectedYear);
    }

    public toggleBrandSaveDialogVisibility() {
        let hasChange = this.hasUnsavedBrandSessionTarget();
        if (hasChange) {
            if (confirm('Are you sure you want to cancel? any unsaved change will be lost.')) {
                this.caller.updateSessionBrandDisplay();
            }
        }
    }

    /**
     * Toggle the dialog for displaying confirmation on deleting a content type exception
     */
    public toggleBrandContentTypeSaveDialogVisibility() {
        document.getElementById('dialog-brand-content-type-save').classList.toggle('is-visible');
    }


    public toggleContentTypeDeleteDialogVisibility() {
        document.getElementById('dialog-content-type-delete').classList.toggle('is-visible');
    }


    public onBlurInputSessionTarget(data, event) {

        let previousValue = event.target.getAttribute('data-previous-value');

        if (previousValue != data.sessionTarget) {

            this.getTemplateViewModel().unsavedBrandTargets(true);
        }
    }

    public hasUnsavedBrandSessionTarget() {
        return this.getTemplateViewModel().unsavedBrandTargets();
    }

    public hasUnsavedContentTypes() {
        return (this.getTemplateViewModel().unsavedContentTypes().length > 0);
    }

    public setRefreshContentTypeFlag(flag) {
        return this.getTemplateViewModel().isRefreshContentType(flag);
    }

    public isRefreshContentType(): boolean {
        return this.getTemplateViewModel().isRefreshContentType();
    }

    /**
     * Clear all unsaved target session brands
     */
    public resetUnsavedBrandSessionTarget() {
        this.getTemplateViewModel().unsavedBrandTargets(false);
    }

    public resetUnsavedContentTypes() {
       this.getTemplateViewModel().unsavedContentTypes([]);
    }

    public setFallback(fallback:number): void {
        this.getTemplateViewModel().fallback(fallback);
    }

    public getFallback(): number {
        return this.getTemplateViewModel().fallback();
    }

    public setSaveFallback(saveFallback: boolean): void {
        this.getTemplateViewModel().saveFallback(saveFallback);
    }

    public getSaveFallback(): boolean {
        return this.getTemplateViewModel().saveFallback();
    }

    public setValidationSessionTargetsExceptions(messages) {
        this.contentTypeExceptionsTargets.setValidationSessionTargetsExceptions(messages);
    }

    public insertSessionTargetsExceptions(): void {
        this.contentTypeExceptionsTargets.resetAndHide();
        this.caller.updateSessionBrandDisplay();
    }

    public resetContentTypesExceptions(): void {
        let hasUnsavedContentTypes = this.hasUnsavedContentTypes()
        if (hasUnsavedContentTypes) {
            this.toggleBrandSaveDialogVisibility();
        } else {

            this.contentTypeExceptionsTargets.resetAndHide();
        }
    }

    public getSavingElement(): Element {
        return this.contentTypeExceptionsTargets.getSavingElement();
    }


}


// WEBPACK FOOTER //
// ./js/components/templates/articleSessionTab_template.ts